<template>
  <div class="layout">
    <div class="rooms-calendar">
      <RoomsCalendar :center="center" />
    </div>
    <div class="rooms-list">
      <RoomsList :rooms="filteredRooms" />
    </div>
  </div>
</template>

<script>
import RoomsCalendar from "@/components/components-salles/public/room/list/subcomponent/RoomsCalendar.vue";
import RoomsList from "@/components/components-salles/public/room/list/subcomponent/RoomsList.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "RoomsOverview",
  components: {
    RoomsCalendar,
    RoomsList,
  },
  computed: {
    ...mapGetters("locationModule", { locations: "getLocations" }),
    ...mapGetters("centerModule", {
      centers: "getCenters",
      centerById: "getCenterById",
    }),
    ...mapGetters("roomModule", { rooms: "getRooms" }),
    filteredRooms() {
      return this.rooms.filter(
        (x) => x.center.id == this.$route.params.id && x.available == true
      );
    },
    center() {
      return this.centerById(this.$route.params.id);
    },
  },
  methods: {
    ...mapActions("locationModule", ["loadLocations"]),
    ...mapActions("centerModule", ["loadCenters"]),
    ...mapActions("roomModule", ["loadRooms"]),
    async initialize() {
      if (!this.locations || this.locations.length < 1)
        await this.loadLocations();
      if (!this.centers || this.centers.length < 1) await this.loadCenters();
      if (!this.rooms || this.rooms.length < 1) await this.loadRooms();
    },
  },
  async mounted() {
    await this.initialize();
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-flow: row;
}

.rooms-calendar {
  flex-flow: column;
  order: 1;
  flex: 2 1 auto;
}

.rooms-list {
  flex-flow: column;
  order: 2;
  flex: 1 1 auto;
}
</style>
